export const IS_LOADING = "IS_LOADING";
export const IS_OPEN = "IS_OPEN";
